import React, { useState, useEffect } from 'react';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';

/**
 * Composant d'affichage d'un chargement global pour les opérations critiques
 * comme le rafraîchissement de l'authentification
 */
const GlobalLoader = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('Chargement...');

  useEffect(() => {
    // Écouteur pour les opérations de rafraîchissement d'authentification
    const handleAuthRefreshStart = (event) => {
      setMessage(event.detail?.message || 'Rafraîchissement de votre session...');
      setLoading(true);
    };

    const handleAuthRefreshEnd = () => {
      setLoading(false);
    };

    // Écouter les événements de début et fin de rafraîchissement
    window.addEventListener('auth-refresh-start', handleAuthRefreshStart);
    window.addEventListener('auth-refresh-end', handleAuthRefreshEnd);
    window.addEventListener('firebase-token-refreshed', handleAuthRefreshEnd);

    return () => {
      window.removeEventListener('auth-refresh-start', handleAuthRefreshStart);
      window.removeEventListener('auth-refresh-end', handleAuthRefreshEnd);
      window.removeEventListener('firebase-token-refreshed', handleAuthRefreshEnd);
    };
  }, []);

  return (
    <Backdrop
      sx={{ 
        color: '#fff', 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
        gap: 2
      }}
      open={loading}
    >
      <CircularProgress color="inherit" />
      <Typography variant="h6" component="div">
        {message}
      </Typography>
      <Box sx={{ mt: 1 }}>
        <Typography variant="body2" color="inherit">
          Veuillez patienter...
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default GlobalLoader; 